import { Button, Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import CloseIcon from '@material-ui/icons/Close';
import { v4 as uuidv4 } from 'uuid';
import { useDispatch } from 'react-redux';
import { ErrorToast, notifySuccess } from '../utils/Utils';
import service from '../../apis/service';
import { getJourneyDetails, showProgress } from '../../redux/actions/DealershipActions';
import { CheckinWrapper } from '../common/CheckinWrapper';
import { apiEndpoints } from '../../constants/apiEndpoints';

function HandleCheckin(props) {
  const [questions, setQuestions] = useState([]);
  const [responseQuestionIds, setResponseQuestionIds] = useState([]);
  const dispatch = useDispatch();

  const getInitalQuestion = () => {
    const initialQuestion = {
      id: uuidv4(),
      type: 'radio',
      text: '',
      options: {
        list: [
          { id: uuidv4(), text: '' },
          { id: uuidv4(), text: '' },
          { id: uuidv4(), text: '' },
          { id: uuidv4(), text: '' },
        ],
        mandatory: true,
      },
    };
    return initialQuestion;
  };

  const storeIds = (res) => {
    const temp = {};

    res.form.list.forEach((ques) => {
      if (ques.type !== 'slider') {
        temp[ques.id] = ques.options.list.map((opt) => opt.id);
      } else {
        temp[ques.id] = [];
      }
    });
    setResponseQuestionIds(temp);
  };

  const fetchDataById = async () => {
    dispatch(showProgress(true));
    try {
      const response = await service.get(apiEndpoints.JOURNEY_CHECKIN.replace('CHECKIN_ID', props.checkinId));
      storeIds(response);
      setQuestions(response.form.list);
      dispatch(showProgress(false));
    } catch (error) {
      dispatch(showProgress(false));
      ErrorToast(error);
    }
  };

  useEffect(() => {
    if (props.mode === 'edit') {
      fetchDataById();
    } else {
      setQuestions([getInitalQuestion()]);
    }
  }, []);

  const validateCheckin = () => {
    const isFieldEmpty = (field) => field.trim() === '';
    const errors = [];

    questions.forEach((question) => {
      if (isFieldEmpty(question.text)) {
        errors.push('Question and Option feilds cannot be empty');
      }

      if (question.type !== 'slider') {
        if (question.options.list.length < 2) {
          errors.push('Enter at least two answer options');
        } else {
          question.options.list.forEach((option) => {
            if (isFieldEmpty(option.text)) {
              errors.push('Question and Option feilds cannot be empty');
            }
          });
        }
      }
    });

    if (errors.length > 0) {
      ErrorToast(errors[0]);
      return false;
    }

    return true;
  };

  const onSubmit = async () => {
    if (!validateCheckin()) {
      return;
    }
    dispatch(showProgress(true));

    if (props.mode === 'edit') {
      try {
        await service.put(apiEndpoints.JOURNEY_CHECKIN_UPDATE.replace('CHECKIN_ID', props.checkinId), {
          journeyId: props.journeyId,
          questions,
        });
        dispatch(showProgress(false));
        props.close();
        notifySuccess('Completed Successfully');
      } catch (error) {
        dispatch(showProgress(false));
        ErrorToast(error);
      }
    } else {
      try {
        const response = await service.post(apiEndpoints.JOURNEY_CHECKIN_CREATE, {
          journeyId: props.journeyId,
          questions,
        });
        dispatch(getJourneyDetails('ADD_CHECKIN_ID', response));
        dispatch(showProgress(false));
        props.close();
        notifySuccess('Completed Successfully');
      } catch (error) {
        dispatch(showProgress(false));
        ErrorToast(error);
      }
    }
  };

  return (
    <Modal
      isOpen={props.open}
      onRequestClose={() => false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          backgroundColor: 'hsla(50, 33%, 25%, 0.35)',
        },
        content: {
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          border: 0,
          height: '80vh',
          width: '900px',
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        },
      }}
    >
      <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
        <Grid item>
          <Grid item>{props.mode === 'add' ? 'Add Check-in' : 'Edit Check-in'}</Grid>
        </Grid>
        <Grid item>
          <CloseIcon onClick={props.close} style={{ cursor: 'pointer' }} />
        </Grid>
      </Grid>

      <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
        {questions.length > 0 && (
          <CheckinWrapper
            questionList={questions}
            setQustionList={setQuestions}
            responseQuestionIds={responseQuestionIds}
          />
        )}
      </Grid>
      <Grid container direction="row" justifyContent="flex-end" alignItems="center">
        <Button onClick={props.close} variant="outlined">
          Cancel
        </Button>
        <Button variant="contained" color="primary" style={{ marginLeft: '10px' }} onClick={onSubmit}>
          Save
        </Button>
      </Grid>
    </Modal>
  );
}

export default HandleCheckin;
